import React, { ReactNode } from 'react';

import { useSidebar } from '~/hooks/sidebar';

import { Page, Container } from './styles';

import { NavBar } from '../..';

type Props = {
  children?: ReactNode;
};

const PageContainerWithoutSidebar: React.FC = ({ children }: Props) => {
  const { isSidebarOpened } = useSidebar();
  return (
    <Container isSidebarOpened={isSidebarOpened}>
      <NavBar />
      <div>
        <Page>{children}</Page>
      </div>
    </Container>
  );
};

export default PageContainerWithoutSidebar;
